import { ScenarioCounts } from '@/interfaces/IScenarioCounts';
import { WorkflowType } from 'src/enums/EWorkflow';
import { safeJSONParse } from './helper';
export const initializeScenarioCounts = (userData: any): ScenarioCounts => {
	const counts: ScenarioCounts = {
		[WorkflowType.TEXT]: 0,
		[WorkflowType.CALL]: 0,
		[WorkflowType.CALENDAR]: 0,
		[WorkflowType.WEBHOOK]: 0,
		[WorkflowType.INTAKE]: 0,
		[WorkflowType.EMAIL]: 0,
		total: 0,
	};

	const workflowCounter = (workflows: any, workflowType: WorkflowType) => {
		try {
			const workflowsData = safeJSONParse(workflows, []);
			counts[workflowType] = Array.isArray(workflowsData) ? workflowsData.length : 0;
		} catch {
			counts[workflowType] = 0;
		}
	};

	if (userData?.workflows) {
		workflowCounter(userData.workflows, WorkflowType.TEXT);
	}

	if (userData?.callWorkflows) {
		workflowCounter(userData.callWorkflows, WorkflowType.CALL);
	}

	if (userData?.call_webhook_workflows) {
		workflowCounter(userData.call_webhook_workflows, WorkflowType.WEBHOOK);
	}

	if (userData?.emailWorkflows) {
		workflowCounter(userData.emailWorkflows, WorkflowType.EMAIL);
	}

	if (userData?.intake_questions_workflows) {
		workflowCounter(userData.intake_questions_workflows, WorkflowType.INTAKE);
	}

	counts[WorkflowType.CALENDAR] = 0;

	counts.total =
		counts[WorkflowType.TEXT] +
		counts[WorkflowType.CALL] +
		counts[WorkflowType.CALENDAR] +
		counts[WorkflowType.WEBHOOK] +
		counts[WorkflowType.INTAKE] +
		counts[WorkflowType.EMAIL];

	return counts;
};
